import React from 'react';
import { toFlag } from 'pano-utils';
import type { CFLink } from '@types';
import { Collapse } from '@components/Collapse';
import LinkSetting from '../components/LinkSetting';
import { useCustomFeature } from '../CustomFeatureContext';

function CLinkSetting() {
  const { data, setData } = useCustomFeature<CFLink>();
  return (
    <Collapse title="超链接设置">
      <LinkSetting
        value={data.linkUrl}
        linkTarget={data.openMethod}
        modalSizeType={data.modalSizeType}
        size={data.size}
        openStyle={data.openStyle}
        isRequired
        isMusicToggleOn={!!data.turnOffBgMusicWhenLayerOpen}
        onChange={(val) =>
          setData((draft) => {
            draft.linkUrl = val;
          })
        }
        onTargetChange={(k) =>
          setData((draft) => {
            draft.openMethod = k;
          })
        }
        onMusicToggleChange={(bool) =>
          setData((draft) => {
            draft.turnOffBgMusicWhenLayerOpen = toFlag(bool);
          })
        }
        onModalSizeTypeChange={(k) => {
          setData((draft) => {
            draft.modalSizeType = k;
          });
        }}
        onModalSizeChange={(val) => {
          setData((draft) => {
            draft.size = val;
          });
        }}
        onOpenStyleChange={(val) => {
          setData((draft) => {
            draft.openStyle = val;
          });
        }}
      />
    </Collapse>
  );
}

export default CLinkSetting;
